(function () {
  if (window.__k9ReviewStarsInit) return;
  window.__k9ReviewStarsInit = true;

  function getScrollTopWithOffset(el, offset) {
    var y = el.getBoundingClientRect().top + window.pageYOffset - offset;
    return Math.max(y, 0);
  }

  function smoothScrollTo(el, offset) {
    window.scrollTo({
      top: getScrollTopWithOffset(el, offset),
      behavior: 'smooth'
    });
  }

  var okendoSelectors = [
    '#okendo-reviews-widget',
    '#oke-reviews-widget',
    '.okeReviews',
    '[data-oke-reviews-widget]',
    '[data-oke-reviews]',
    '#reviews'
  ];

  function findOkendoEl() {
    for (var i = 0; i < okendoSelectors.length; i++) {
      var el = document.querySelector(okendoSelectors[i]);
      if (el) return el;
    }
    return null;
  }

  function scrollToTarget(mode, linkId, offset, tries) {
    tries = tries || 12;

    if (mode === 'anchor') {
      var anchor = document.getElementById(linkId);
      if (anchor) {
        smoothScrollTo(anchor, offset);
        return;
      }
      window.location.hash = '#' + linkId;
      return;
    }

    var el = findOkendoEl();
    if (el) {
      smoothScrollTo(el, offset);
      return;
    }

    if (tries > 0) {
      setTimeout(function () {
        scrollToTarget(mode, linkId, offset, tries - 1);
      }, 250);
    } else {
      window.location.hash = '#' + linkId;
    }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-k9-review-stars]');
    if (!trigger) return;

    e.preventDefault();

    var mode = trigger.getAttribute('data-scroll-mode') || 'okendo';
    var offset = parseInt(trigger.getAttribute('data-scroll-offset') || '0', 10) || 0;
    var linkId = trigger.getAttribute('data-link-id') || 'reviews';

    scrollToTarget(mode, linkId, offset);
  });
})();